import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Anchor } from "~/components/Anchor";
import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetUserEvents } from "~/modules/analytics/events/assets";
import { AssetColumns } from "~/modules/assets/types";
import { extractDomainName } from "~/utils/extractDomainName";
import { AssetTableRowData } from "../types";

// // // //

export const WEBSITE_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> = {
    slug: "Website",
    label: "Website",
    type: ColumnTypes.string,
    width: 200,
    render: (item) => {
        if (!item.isAsset) return null;

        const url = item.website;
        if (!url) return <Emdash />;

        const domain = extractDomainName(url);

        return (
            <Anchor
                openInNewTab
                href={url}
                analyticsLabel={AssetUserEvents.ClickWebsiteLink}
                variant="default"
                className="flex items-center gap-2"
            >
                {domain}
                <FontAwesomeIcon
                    icon={faArrowUpRightFromSquare}
                    className="w-3 h-3"
                />
            </Anchor>
        );
    },
};
